import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Section } from '../../globalStyles';
import {
	TeamContainer,
	TeamWrapper,
	TeamTitle,
	TeamSubtitle,
	TeamGrid,
	TeamCard,
	TeamImage,
	TeamInfo,
	TeamName,
	TeamPosition,
} from './TeamStyles.js';

import { useInView } from 'react-intersection-observer';
import { useAnimation } from 'framer-motion';

// Importar las imágenes
import nicolasVila from '../../assets/people/nicolas-vila.jpeg';
import rodrigoVila from '../../assets/people/rodrigo-vila.jpeg';
import mariaBallester from '../../assets/people/maria-ballester-molina.jpeg';
import alejandroMonsegur from '../../assets/people/alejandro-monsegur.jpeg';
import federicoRolle from '../../assets/people/federico-rolle.jpeg';
import rodolfoWilliams from '../../assets/people/rodolfo-williams.jpeg';
import florenciaFernandez from '../../assets/people/florencia-fernandez.jpeg';

export const Team = ({ inverse }) => {
	const { t } = useTranslation();
	const initial = { opacity: 0, y: 30 };
	const animation = useAnimation();

	const { ref, inView } = useInView({ threshold: 0.2 });

	useEffect(() => {
		if (inView) {
			animation.start({
				opacity: 1,
				y: 0,
			});
		}
	}, [inView, animation]);

	const teamMembers = [
		{
			name: t("team.members.rodrigo.name", "Rodrigo Vila"),
			position: t("team.members.rodrigo.position", "Director general"),
			image: rodrigoVila,
		},
		{
			name: t("team.members.nicolas.name", "Nicolás Vila"),
			position: t("team.members.nicolas.position", "Gerencia comercial"),
			image: nicolasVila,
		},
		{
			name: t("team.members.maria.name", "María Ballester Molina"),
			position: t("team.members.maria.position", "Administración y gestión"),
			image: mariaBallester,
		},
		{
			name: t("team.members.alejandro.name", "Alejandro Monsegur"),
			position: t("team.members.alejandro.position", "Sistemas"),
			image: alejandroMonsegur,
		},
		{
			name: t("team.members.federico.name", "Federico Rolle"),
			position: t("team.members.federico.position", "Ingeniero agrónomo"),
			image: federicoRolle,
		},
		{
			name: t("team.members.rodolfo.name", "Rodolfo Williams"),
			position: t("team.members.rodolfo.position", "Gerencia financiera"),
			image: rodolfoWilliams,
		},
		{
			name: t("team.members.florencia.name", "Florencia Fernández"),
			position: t("team.members.florencia.position", "Ingeniera agrónoma"),
			image: florenciaFernandez,
		},
	];


	return (
		<Section inverse={inverse} ref={ref}>
			<Container>
				<TeamContainer>
					<TeamWrapper>
						<TeamTitle
							initial={initial}
							transition={{ delay: 0.1, duration: 0.4 }}
							animate={animation}
							inverse={inverse}
						>
							{t("team.title")}
						</TeamTitle>
						<TeamSubtitle
							initial={initial}
							transition={{ delay: 0.2, duration: 0.4 }}
							animate={animation}
							inverse={inverse}
						>
							{t("team.subtitle")}
						</TeamSubtitle>
						<TeamGrid
							initial={initial}
							transition={{ delay: 0.3, duration: 0.4 }}
							animate={animation}
						>
							{teamMembers.map((member, index) => (
								<TeamCard
									key={index}
									initial={{ opacity: 0, y: 30 }}
									animate={{ opacity: 1, y: 0 }}
									transition={{ delay: 0.4 + index * 0.05, duration: 0.4 }}
									inverse={inverse}
									// whileHover={{ y: -5, transition: { duration: 0.3 } }}
								>
									<TeamImage src={member.image} alt={member.name} />
									<TeamInfo>
										<TeamName inverse={inverse}>
											{member.name}
										</TeamName>
										<TeamPosition inverse={inverse}>
											{member.position}
										</TeamPosition>
									</TeamInfo>
								</TeamCard>
							))}
						</TeamGrid>
					</TeamWrapper>
				</TeamContainer>
			</Container>
		</Section>
	);
};
